import React from 'react';
import {connect} from 'react-redux';
import {requestDisertations, setCurrentPage} from "../../redux/disertation-reducer";
import {Container, Row} from "react-bootstrap";
import {NavLink, withRouter} from "react-router-dom";
import {compose} from "redux";
import Disertations from './Disertations';
import {getPageFromLocation, pushPage} from "../../shared/pagination";

class DisertationsContainer extends React.Component {

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search
            || prevProps.match.params.id !== this.props.match.params.id) {
            this.load();
        }
    }

    load() {
        this.props.requestDisertations(
            getPageFromLocation(this.props.location), this.props.pageSize, this.props.match.params.id
        );
    }

    onPageChanged = (pageNumber) => {
        pushPage(this.props.history, this.props.location, pageNumber);
    }

    render() {

        return <>
            <div className={'breadcrumdBottom'}>
                <Container className=''>
                    <Row>
                        <div className={'breadcrumdCont'}>
                            <NavLink to={'/'}>
                                <div className={'breadcrumbTitle'}>eLibrary</div>
                            </NavLink>
                            <div className={'breadcrumbItem'}>Диссертации</div>
                                <div className={'breadcrumbItem'}>
                                    {this.props.napravlenie}
                                </div>
                            <div className={'breadcrumbItem'}>{this.props.spec}</div>
                        </div>
                    </Row>
                </Container>
            </div>





            <Disertations
                totalCount={this.props.totalCount}
                pageSize={this.props.pageSize}
                currentPage={this.props.currentPage}
                onPageChanged={this.onPageChanged}
                articles={this.props.articles}
                spec={this.props.spec}
                napravlenie={this.props.napravlenie}
                loading={this.props.isFetching}
            />

        </>
    }
}

let mapStateToProps = (state) => {
    return {
        totalCount: state.disertation.totalCount,
        pageSize: state.disertation.pageSize,
        currentPage: state.disertation.currentPage,
        articles:  state.disertation.disertations,
        isFetching: state.disertation.isFetching,
        napravlenie: state.disertation.napravlenie,
        spec: state.disertation.spec
    }
}

export default compose(
    connect(mapStateToProps, {setCurrentPage,requestDisertations}),
    withRouter
)(DisertationsContainer);
